/**
 * @author       Matthieu Devlin (matt@zumper.com)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  pageTitleBuildingDetails.js
 */

import { BuildingLabel, getEnumTitle } from '@zcode/enums'
import type { Building } from '@zcode/state-type'
import { joinAddress } from '../../../shared/utils/address'

const ADDRESS_HIDDEN = '(address hidden)'

export const pageTitleBuildingDetails = (building: Building) => {
  const address = building.address?.includes(ADDRESS_HIDDEN) ? '' : building.address
  const buildingLabel = building.buildingLabel
    ? getEnumTitle(BuildingLabel, building.buildingLabel)
    : undefined
  const name = building.name || address || ('' as const)
  const hood = building.neighborhood
  const city = building.city || ('' as const)
  let slug = 'Apartment Building'
  const state = building.state || hood?.state || ('' as const)

  if (name && !name.includes(ADDRESS_HIDDEN)) {
    if (buildingLabel) {
      const buildingLabelSingular = buildingLabel.endsWith('s')
        ? buildingLabel.slice(0, -1)
        : buildingLabel
      if (
        name.toLowerCase().includes(buildingLabel.toLowerCase()) ||
        name.toLowerCase().includes(buildingLabelSingular.toLowerCase())
      ) {
        slug = name
      } else {
        slug = `${name} ${buildingLabel}` as const
      }
    } else {
      if (name.toLowerCase().includes('apartment')) {
        slug = name
      } else {
        slug = `${name} Apartments` as const
      }
    }
    slug = slug.replace(' for Rent', '')
    if (address?.includes(name)) {
      if (city) {
        return `${slug} - ${joinAddress(' ', city, state)}` as const
      }
      return slug
    }
    return `${slug} - ${joinAddress(' ', address, city, state)}` as const
  }
  if (city) {
    return `${slug} - ${joinAddress(' ', city, state)}` as const
  }
  return slug
}
